/**
 * Utilities for rendering WYSIWYG content safely.
 *
 * The CMS stores HTML in fields like `about_long`, `vision`, `mission`,
 * `quality_policy`, `volunteer_program_description`, etc. Rendering the
 * string directly with {value} shows the raw <p></p> tags to visitors —
 * we need to either strip HTML (for tight one-liners) or render it as HTML
 * (for content bodies).
 */

/**
 * Strip HTML tags and collapse whitespace. Also decodes a few common
 * HTML entities (&amp;, &nbsp;, &quot;, &#39;, &lt;, &gt;).
 *
 * @param {string} html
 * @returns {string} plain-text single-line string
 */
export const stripHtml = (html) => {
    if (!html || typeof html !== 'string') return '';
    return html
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<\/?(p|div|li|h[1-6]|blockquote)[^>]*>/gi, ' ')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/\s+/g, ' ')
        .trim();
};

/**
 * True if the provided string looks like HTML content (contains any tag).
 */
export const isHtml = (value) =>
    typeof value === 'string' && /<[a-zA-Z][^>]*>/.test(value);
